<template>

  <a-card
    style="margin-top: 24px"
    :bordered="false"
    :title="cardTitle"
  >
    <div slot="extra">
      <a-date-picker @change="handleOrderDate" />
    </div>
    <!-- 表格 -->
    <a-table
      :columns="tableColumns"
      :dataSource="tableData"
      bordered
      :pagination="false"
      :loading="tableLoading"
      size="small"
    >
      <!-- 菜品 -->
      <span
        slot="menuImg"
        slot-scope="text"
      >
        <a-avatar
          :key="text"
          :src="text"
          shape="square"
          style="margin:0 2px;border:1px solid #e8e8e8"
        />
      </span>
    </a-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { GetTodayOrderList } from '@/apis/order'

const tableColumns = [{
  title: '#',
  dataIndex: 'num',
  key: 'num',
  align: 'center'
}, {
  title: '菜品',
  dataIndex: 'menuName',
  key: 'menuName',
  align: 'center'
}, {
  title: '菜品图',
  dataIndex: 'menuImg',
  key: 'menuImg',
  scopedSlots: { customRender: 'menuImg' },
  align: 'center'
}, {
  title: '早餐',
  align: 'center',
  children: [
    {
      title: '点餐人数',
      dataIndex: 'breakfastPeopleCount',
      key: 'breakfastPeopleCount',
      align: 'center'
    }, {
      title: '点餐份数',
      dataIndex: 'breakfastMenuCount',
      key: 'breakfastMenuCount',
      align: 'center'
    }
  ]
}, {
  title: '午餐',
  align: 'center',
  children: [
    {
      title: '点餐人数',
      dataIndex: 'lunchPeopleCount',
      key: 'lunchPeopleCount',
      align: 'center'
    }, {
      title: '点餐份数',
      dataIndex: 'lunchMenuCount',
      key: 'lunchMenuCount',
      align: 'center'
    }
  ]
}, {
  title: '晚餐',
  align: 'center',
  children: [
    {
      title: '点餐人数',
      dataIndex: 'dinnerPeopleCount',
      key: 'dinnerPeopleCount',
      align: 'center'
    }, {
      title: '点餐份数',
      dataIndex: 'dinnerMenuCount',
      key: 'dinnerMenuCount',
      align: 'center'
    }
  ]
}];

export default {
  data() {
    return {
      tableData: [],
      tableColumns,
      tableLoading: false,
      todayOrderDate: '',
      cardTitle: `今日订单 | ${moment().format('YYYY-MM-DD')}`
    }
  },
  methods: {
    // monment
    moment,
    handleOrderDate(date) {
      this.todayOrderDate = date
      this._GetTodayOrderList()
    },
    _GetTodayOrderList() {
      this.tableLoading = true
      let selectDate = (this.todayOrderDate === '' || this.todayOrderDate === null) ? moment().format('YYYY-MM-DD') : this.todayOrderDate.format('YYYY-MM-DD')
      this.cardTitle = `今日订单 | ${selectDate}`

      GetTodayOrderList({
        date: selectDate
      }).then(res => {
        let resault = res.data

        if (resault.state === 1) {
          this.tableData = []
          resault.attribute.forEach((item, index) => {
            this.tableData.push({
              key: item.company_MenuId,
              num: index + 1,
              menuName: item.name,
              menuImg: item.imgUrl,
              breakfastPeopleCount: item.beakfastCount,
              breakfastMenuCount: item.beakfastAmount,
              lunchPeopleCount: item.lunchCount,
              lunchMenuCount: item.lunchAmount,
              dinnerPeopleCount: item.dinnerCount,
              dinnerMenuCount: item.dinnerAmount
            })
          })
        }

        this.tableLoading = false
      }, res => {
        this.tableLoading = false
      })
    }
  },
  created() {
    // 页面加载完毕
    this._GetTodayOrderList()
  }
}
</script>

<style lang="less" scoped>
</style>

<style lang="less">
// 覆盖antd样式
.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #fafafa !important;
}

.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}
</style>
